import { Button, makeStyles } from '@fluentui/react-components';
import { ReOrderDotsVertical20Filled } from '@fluentui/react-icons';
import { useRefreshCounter } from '@morning-dashboard/hooks/useRefreshCounter';
import { devComponentName } from '@morning-dashboard/helpers/isDevEnv';
import { Box } from '../../../../../theme/fluent';

export const useDragButtonPropsStyles = makeStyles({
  controls: {
    marginLeft: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
  },
  btn: {
    pointerEvents: 'all',
  },
});

const DragButton: React.FC = () => {
  const classes = useDragButtonPropsStyles();
  const { isCustomizeOpened } = useRefreshCounter();

  return (
    isCustomizeOpened && (
      <Box {...devComponentName('DragButton')} className={classes.controls}>
        <Button icon={<ReOrderDotsVertical20Filled />} appearance="subtle" className={classes.btn} />
      </Box>
    )
  );
};

export default DragButton;
